/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import { CircularProgress, Paper } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';
import { openImageViewer } from '@src/actions/common';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import ChatMessageCaption from '../ChatMessage/ChatMessageCaption';

type ChatMessageImageProps = {
  mediaUrl: string;
  mediaSize?: string;
  caption?: string;
};

const ChatMessageImage: React.FC<ChatMessageImageProps> = ({
  mediaUrl,
  caption,
}) => {
  const dispatch = useDispatch();
  const [isLoadedImage, setIsLoadedImage] = useState(false);

  return (
    <ChatMessageCaption caption={caption}>
      <Paper
        style={{
          maxWidth: 330,
          overflow: 'hidden',
        }}
        elevation={0}
      >
        {mediaUrl ? (
          <>
            {!isLoadedImage && (
              <Skeleton
                variant="rect"
                width={330}
                height={330}
                style={{ borderRadius: 5, backgroundColor: '#d7d7da' }}
              />
            )}

            <div
              style={{ cursor: 'pointer', lineHeight: 0 }}
              onClick={() => dispatch(openImageViewer(mediaUrl))}
            >
              <img
                alt="message-alt"
                src={mediaUrl}
                onLoad={() => setIsLoadedImage(true)}
                style={{
                  width: 'auto',
                  maxHeight: 330,
                  maxWidth: '100%',
                  objectFit: 'cover',
                  display: isLoadedImage ? 'block' : 'none',
                }}
              />
            </div>
          </>
        ) : (
          <div
            style={{
              width: 120,
              height: 120,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <CircularProgress />
          </div>
        )}
      </Paper>
    </ChatMessageCaption>
  );
};

export default ChatMessageImage;
